import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { setLoading } from 'redux/actions/GeneralAction';

import TnCPage from './TnCPage.page';

const mapStateToProps = () => ({});
const mapDispatchToProps = { setLoading };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(TnCPage));
